import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {projectTitleInitialState} from '../reducers/project-title';
let ipconfig = require( '../../ipconfig.json');

import classNames from 'classnames';
import styles from '../components/menu-bar/menu-bar.css';


/**
 * Project saver component passes a downloadProject function to its child.
 * It expects this child to be a function with the signature
 *     function (downloadProject, props) {}
 * The component can then be used to attach project saving functionality
 * to any other component:
 *
 * <SB3Downloader>{(downloadProject, props) => (
 *     <MyCoolComponent
 *         onClick={downloadProject}
 *         {...props}
 *     />
 * )}</SB3Downloader>
 */
class SB3Downloader extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            showLoader: false
        }
        bindAll(this, [
            'downloadProject'
        ]);
    }
    
    downloadProject () {
        let getCookie = (cname) => {
            let name = cname + "=";
            let ca = document.cookie.split(';');
            for(let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        let hideLoader = () => {
            setTimeout( ()=>{
                this.setState({ showLoader: false } );
            }, 1500 );
        }

        let submit_project = () => {
            let start = new Date().getTime();

            this.setState( {showLoader: true }, () => {
    
                this.props.saveProjectSb3().then(content => {
                    
                    var formData = new FormData();
                    formData.append( "file", content, this.props.projectFilename );
        
                    // var url = 'http://' + ipconfig.ip + '/projects/' + this.props.projectFilename;
                    let student_id = getCookie( "stemground_student_id" );
                    let device_no = getCookie( "stemground_device_no" );
                    let is_final = ( this.props.isFinal || 0 );
                    // fetch("http://" + ipconfig.ip + "/upload.php?student_id=" + student_id + "&device_no=" + device_no + "&is_final=" + is_final, {
                    fetch("upload.php?student_id=" + student_id + "&device_no=" + device_no + "&is_final=" + is_final, {
                        method: "POST", // *GET, POST, PUT, DELETE, etc.
                        body: formData, // body data type must match "Content-Type" header
                    }).then( ( result ) => {
                        // if (this.props.onSaveFinished) {
                        //     this.props.onSaveFinished();
                        // }

                        let v_now = new Date().getTime();
                        let v_time = 1500 - ( v_now - start );
                        v_time = v_time < 0 ? 1 : v_time;

                        setTimeout( ()=>{
                            this.setState({ showLoader: false }, ()=>{
                                if ( this.props.isFinal == 1 ) {
                                    alert( "Project has been successfully submitted" );
                                } else {
                                    alert( "Project saved!" );
                                }
                            } );
                        }, v_time );
                    })
                    
        
                });
            })
        }

        if ( this.state.showLoader == false ) {
            let pin = '';
            if ( this.props.isFinal == 1 ) {
                pin = prompt( "Enter PIN" );
                // console.log( "PIN::", pin );
                var formBody = "pin=" + pin;
                // for (var property in details) {
                //     var encodedKey = encodeURIComponent(property);
                //     var encodedValue = encodeURIComponent(details[property]);
                //     formBody.push(encodedKey + "=" + encodedValue);
                // }
                // formBody = formBody.join("&");

                if ( ( pin ?? null ) != null && pin != '' ) {
                    // fetch( "http://" + ipconfig.ip + "/ajax-verify-pin.php", {
                    fetch( "ajax-verify-pin.php", {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                          },
                        body: formBody
                    }).then((response) => response.json())
                    .then((responseData) => {
                        if ( responseData.status == "error" ) {
                            alert( "Project submission failed!\n" + responseData.msg );
                            return false;
                        }

                        submit_project();
                    //    console.log(JSON.stringify(responseData))
                    })
                }

                return false;
            } else {
                submit_project();
            }
            
        }
        
        

    }
    render () {
        const {
            children
        } = this.props;
        return <div className={classNames(styles.saveProjectContainer)}>
            {children(
                this.props.className,
                this.downloadProject
            )}
            { this.state.showLoader &&
                <div className={classNames(styles.loader)}></div>
            }
        </div>;
    }
}

const getProjectFilename = (curTitle, defaultTitle) => {
    let filenameTitle = curTitle;
    if (!filenameTitle || filenameTitle.length === 0) {
        filenameTitle = defaultTitle;
    }
    return `${filenameTitle.substring(0, 100)}.sb3`;
};

SB3Downloader.propTypes = {
    children: PropTypes.func,
    className: PropTypes.string,
    onSaveFinished: PropTypes.func,
    onPress: PropTypes.func,
    projectFilename: PropTypes.string,
    saveProjectSb3: PropTypes.func
};
SB3Downloader.defaultProps = {
    className: ''
};

const mapStateToProps = state => ({
    saveProjectSb3: state.scratchGui.vm.saveProjectSb3.bind(state.scratchGui.vm),
    projectFilename: getProjectFilename(state.scratchGui.projectTitle, projectTitleInitialState)
});

export default connect(
    mapStateToProps,
    () => ({}) // omit dispatch prop
)(SB3Downloader);
